import React, { useState, useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/GallerySection.css";
import Header from "../Components/Header";
import bgImage from "../assets/bgImage.png";
import Contactbar from '../Components/ContactBar';

// Images
import venue1 from "../assets/LIBRA EVENTS/new/IMG-20250820-WA0006.jpg";
import venue2 from "../assets/LIBRA EVENTS/new/IMG-20250820-WA0004.jpg";
import venue3 from "../assets/LIBRA EVENTS/new/IMG-20250820-WA0010.jpg";
import venue4 from "../assets/LIBRA EVENTS/WhatsApp Image 2023-12-24 at 7.13.52 PM (14).jpeg";
import venue5 from "../assets/jyoti2.jpg";
import venue6 from "../assets/LIBRA EVENTS/_DSC9636.jpg";

import event1 from "../assets/LIBRA EVENTS/new/IMG-20250822-WA0018.jpg";
import event2 from "../assets/LIBRA EVENTS/new/IMG-20250822-WA0020.jpg";
import event3 from "../assets/LIBRA EVENTS/new/IMG-20250822-WA0041.jpg";
import event4 from "../assets/LIBRA EVENTS/new/IMG-20250822-WA0028.jpg";
import event5 from "../assets/LIBRA EVENTS/new/IMG-20250822-WA0066.jpg";
import event6 from "../assets/LIBRA EVENTS/new/IMG-20250822-WA0077.jpg";


import weddin1 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-01-30 at 12.01.21 PM.jpeg";
import weddin2 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-02-03 at 10.36.56 AM (1).jpeg";
import weddin3 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-02-27 at 3.20.39 PM.jpeg";
import weddin4 from "../assets/LIBRA EVENTS/_PHP0418.jpg";
import weddin5 from "../assets/LIBRA EVENTS/_SDL2382.jpg";
import weddin6 from "../assets/LIBRA EVENTS/36by20.jpg";
import weddin7 from "../assets/LIBRA EVENTS/KSH_2525.jpg";

import RECEPTION1 from "../assets/LIBRA EVENTS/_DSC9636.jpg";
import RECEPTION2 from "../assets/LIBRA EVENTS/_PHP0450.jpg";
import RECEPTION3 from "../assets/LIBRA EVENTS/0O0A4128.jpg";
import RECEPTION4 from "../assets/LIBRA EVENTS/36by20.jpg";
import RECEPTION5 from "../assets/LIBRA EVENTS/1461.jpg";
import RECEPTION6 from "../assets/LIBRA EVENTS/DSC_5653.jpg";
import RECEPTION7 from "../assets/LIBRA EVENTS/KSH_0591.jpg";
import RECEPTION8 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-02-27 at 3.40.41 PM (3).jpeg";
import RECEPTION9 from "../assets/LIBRA EVENTS/KSH_1810.jpg";

import Sangit1 from "../assets/LIBRA EVENTS/KSH_0083.jpg";
import Sangit2 from "../assets/LIBRA EVENTS/KSH_1632.jpg";
import Sangit3 from "../assets/LIBRA EVENTS/KSH_1689.jpg";
import Sangit4 from "../assets/LIBRA EVENTS/WhatsApp Image 2023-12-24 at 7.13.53 PM.jpeg";

import Outdoordecoration1 from "../assets/LIBRA EVENTS/8.jpeg";
import Outdoordecoration2 from "../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.45 PM (1).jpeg";
import Outdoordecoration3 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-01-16 at 8.28.23 PM.jpeg";
import Outdoordecoration4 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-02-27 at 3.20.39 PM.jpeg";
import Outdoordecoration5 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-02-27 at 3.40.41 PM (3).jpeg";
import Outdoordecoration6 from "../assets/LIBRA EVENTS/_PHP0566.jpg";
import Outdoordecoration7 from "../assets/LIBRA EVENTS/1461.jpg";
import Outdoordecoration8 from "../assets/LIBRA EVENTS/DSC_1172.jpg";
import Outdoordecoration9 from "../assets/LIBRA EVENTS/KSH_0612.jpg";

import CORPORATECONFERENCESMEETING1 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7578.jpg";
import CORPORATECONFERENCESMEETING2 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7579.jpg";
import CORPORATECONFERENCESMEETING3 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7586.jpg";
import CORPORATECONFERENCESMEETING4 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7585.jpg";
import CORPORATECONFERENCESMEETING5 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7587.jpg";
import CORPORATECONFERENCESMEETING6 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7593.jpg";
import CORPORATECONFERENCESMEETING7 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7594.jpg";
import CORPORATECONFERENCESMEETING8 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7596.jpg";
import CORPORATECONFERENCESMEETING9 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7601.jpg";

import Footer from "../Components/Footer";

const galleryData = [
  { category: "venue", src: venue1 },
  { category: "venue", src: venue2 },
  { category: "venue", src: venue3 },
  { category: "venue", src: venue4 },
  { category: "venue", src: venue5 },
  { category: "venue", src: venue6 },

  { category: "events", src: event1 },
  { category: "events", src: event2 },
  { category: "events", src: event3 },
  { category: "events", src: event4 },
  { category: "events", src: event5 },
  { category: "events", src: event6 },

  { category: "Reception", src: RECEPTION1 },
  { category: "Reception", src: RECEPTION2 },
  { category: "Reception", src: RECEPTION3 },
  { category: "Reception", src: RECEPTION4 },
  { category: "Reception", src: RECEPTION5 },
  { category: "Reception", src: RECEPTION6 },
  { category: "Reception", src: RECEPTION7 },
  { category: "Reception", src: RECEPTION8 },
  { category: "Reception", src: RECEPTION9 },
  
  { category: "weddings", src: weddin1 },
  { category: "weddings", src: weddin2 },
  { category: "weddings", src: weddin3 },
  { category: "weddings", src: weddin4 },
  { category: "weddings", src: weddin5 },
  { category: "weddings", src: weddin6 },
  { category: "weddings", src: weddin7 },

  { category: "Out Door Decoration", src: Outdoordecoration1 },
  { category: "Out Door Decoration", src: Outdoordecoration2 },
  { category: "Out Door Decoration", src: Outdoordecoration3 },
  { category: "Out Door Decoration", src: Outdoordecoration4 },
  { category: "Out Door Decoration", src: Outdoordecoration5 },
  { category: "Out Door Decoration", src: Outdoordecoration6 },
  { category: "Out Door Decoration", src: Outdoordecoration7 },
  { category: "Out Door Decoration", src: Outdoordecoration8 },
  { category: "Out Door Decoration", src: Outdoordecoration9 },

  { category: "Corporate Conferences & Meeting", src: CORPORATECONFERENCESMEETING1 },
  { category: "Corporate Conferences & Meeting", src: CORPORATECONFERENCESMEETING2 },
  { category: "Corporate Conferences & Meeting", src: CORPORATECONFERENCESMEETING3 },
  { category: "Corporate Conferences & Meeting", src: CORPORATECONFERENCESMEETING4 },
  { category: "Corporate Conferences & Meeting", src: CORPORATECONFERENCESMEETING5 },
  { category: "Corporate Conferences & Meeting", src: CORPORATECONFERENCESMEETING6 },
  { category: "Corporate Conferences & Meeting", src: CORPORATECONFERENCESMEETING7 },
  { category: "Corporate Conferences & Meeting", src: CORPORATECONFERENCESMEETING8 },
  { category: "Corporate Conferences & Meeting", src: CORPORATECONFERENCESMEETING9 },

  { category: "Sangeet", src: Sangit1 },
  { category: "Sangeet", src: Sangit2 },
  { category: "Sangeet", src: Sangit3 },
  { category: "Sangeet", src: Sangit4 }
];

const FilteredGallery = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // 👈 Scroll to top on page load
  }, []);

  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredImages =
    activeCategory === "all"
      ? galleryData
      : galleryData.filter((img) => img.category === activeCategory);

  const categories = ["all", "venue","events", "Reception", "weddings","Sangeet", "Out Door Decoration", "Corporate Conferences & Meeting"];

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section
        className="about-section"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="overlay container text-white text-center py-5">
          <p className="section-subtitle">ALL YOU NEED TO KNOW</p>
          <h1 className="section-title">
            <span className="highlight">LIBRA</span> EVENTS
          </h1>
          <div className="breadcrumbs mt-3">
            <a href="/" className="home-link">
              <span className="home">Home</span>
            </a>
            <span className="divider"> | </span>
            <span className="about">Gallery</span>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <div className="gallery-section text-white">
        <div className="text-center py-5">
          <h1 className="gallery-title">Gallery</h1>
          <p className="gallery-description">
            Explore the vibrant gallery of LIBRA Banquets, showcasing stunning event setups, elegant decor, and memorable celebrations. Visit now!
          </p>
        </div>

        <div className="d-flex justify-content-center mb-4 category-tabs flex-wrap">
          {categories.map((cat) => (
            <div
              key={cat}
              className={`tab-item mx-2 ${
                activeCategory === cat ? "active" : ""
              }`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat.toUpperCase()}
            </div>
          ))}
        </div>

        <div className="container">
          <div className="row g-3">
            {filteredImages.map((img, idx) => (
              <div className="col-12 col-sm-6 col-md-4" key={idx}>
                <img
                  src={img.src}
                  alt={`${img.category}-${idx}`}
                  className="img-fluid gallery-img"
                  onClick={() => setSelectedImage(img.src)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
  <div
    className="modal-overlay"
    onClick={() => setSelectedImage(null)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        maxWidth: "600px",
        width: "90%",
        borderRadius: "10px",
        overflow: "hidden",
        boxShadow: "0 0 15px rgba(255, 255, 255, 0.2)",
      }}
    >
      <img
        src={selectedImage}
        alt="Enlarged"
        className="img-fluid"
        style={{
          width: "100%",
          height: "auto",
          display: "block",
        }}
      /><button
      onClick={() => setSelectedImage(null)}
      style={{
        position: "absolute",
        top: "20px",
        right: "30px",
        fontSize: "2rem",
        color: "#fff",
        background: "transparent",
        border: "none",
        cursor: "pointer",
      }}
    >
      &times;
    </button>
    
    </div>
  </div>
)}

<Contactbar />
<Footer/>

    </>
  );
};

export default FilteredGallery;
